import { Play, Eye, Clock, Flame } from "lucide-react";
import { FaYoutube } from "react-icons/fa";
import { formatCount } from "@/lib/api";
import { usePlayer } from "@/contexts/PlayerContext";

const HERO_FALLBACK = "https://static.prod-images.emergentagent.com/jobs/a757e94a-935c-480c-9c55-c9cb88449182/images/5460ce13366552b4041bb0cff15213c74ec8ecd49904c370f9aa51d8a1670999.png";

export function HeroCard({ video, loading }) {
  const { play } = usePlayer();
  if (loading) {
    return (
      <div className="h-full w-full rounded-2xl bg-bg-surface animate-pulse" />
    );
  }
  if (!video) return null;

  return (
    <button
      type="button"
      onClick={() => play(video)}
      data-testid="hero-card"
      className="block relative h-full w-full overflow-hidden rounded-2xl group shadow-2xl shadow-black/50 border border-white/5 animate-fade-up text-left"
    >
      <img
        src={video.thumbnail || HERO_FALLBACK}
        alt={video.title}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        onError={(e) => { e.currentTarget.src = HERO_FALLBACK; }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-bg via-bg/60 to-bg/10" />
      <div className="absolute inset-0 bg-gradient-to-r from-bg/40 to-transparent" />

      <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-brand/95 text-white text-[11px] font-bold tracking-wider px-2.5 py-1 rounded-md uppercase">
        <Flame size={12} /> Trending
      </span>

      <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-brand rounded-full grid place-items-center text-white shadow-[0_0_30px_rgba(230,59,46,0.55)] animate-pulse-ring">
        <Play size={26} fill="white" className="ml-1" />
      </span>

      <div className="absolute bottom-0 left-0 w-full p-5 flex flex-col gap-2">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold leading-tight text-balance line-clamp-2">
          {video.title}
        </h2>
        <p className="text-white/70 text-sm">{video.channel}</p>
        <div className="flex items-center gap-4 text-white/70 text-xs mt-1">
          <span className="inline-flex items-center gap-1"><Eye size={13} /> {formatCount(video.view_count)}</span>
          <span className="inline-flex items-center gap-1.5"><FaYoutube size={13} className="text-brand" /> {video.source || "YouTube"}</span>
          <span className="inline-flex items-center gap-1"><Clock size={13} /> {video.duration}</span>
        </div>
      </div>
    </button>
  );
}
